import React from 'react';
import EmailRoutingPathListItem from '../email_routing_path/EmailRoutingPathListItem'

export default function EmailRoutingPathList(props) {
    const { geolocations } = props;
    const geoListItems = geolocations.map((geo, index) => {
        return (
            <EmailRoutingPathListItem 
                key={index} 
                label={index === 0 ? "From": "To"} 
                geolocation={geo}
            />
        );
    });
  
    return (
        <ol className="list-group list-group-flush">
            {geoListItems}
        </ol>
    );
  }